

<div class="device-setup-container">


    <div class="title">
        Setup Up Score Tracking Device
    </div>

    <div fxLayout="column" fxLayoutAlign="center center" style="margin-top: 25px; background-color: #000000">

        <div fxFlex style="width: 350px;">

            <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="25px">

                <!--
                <div fxFlex style="text-align: center;" > 
                    * On the real Device Setup page there will be no button this will be automatically checked when the page loads
                </div>      
                -->

                <!-- Socket Status *ngIf="socketConnectedStatus.socketConfigured" -->

                <!-- {{ socketConnectedStatus }} - afdsf -->
                <!-- <mat-card fxFlex  *ngIf="socketConnectedStatus.socketConfigured == 'true'" class="connection-status-container">
                    <div fxLayout="column" fxLayoutGap="15px" style="text-align: center;">

                        <div fxFlex>
                            <b>Socket Connection Status</b>
                        </div>

                        <div fxFlex>
                            <b>SOCKET ID:</b><br/>
                            {{ socketConnectedStatus.socketID }}
                        </div>            

                        <div fxFlex>
                            <b>CONNECTED:</b><br/>
                            {{ socketConnectedStatus.connected }}
                        </div>

                        <div fxFlex>
                            <b>SOCKET CONFIGURED:</b><br/>
                            {{ socketConnectedStatus.socketConfigured }}
                        </div>

                        <div fxFlex>
                            <b>MESSAGE:</b><br/>
                            {{ socketConnectedStatus.message }}
                        </div>                        
                    </div>
                </mat-card> -->

                <div fxFlex>
                    <form #deviceSetupForm="ngForm" class="example-form" (ngSubmit)="onDeviceSetup(deviceSetupForm)">

                        <mat-card fxFlex>

                            <div fxLayout="column"  fxLayoutGap="25px">
                                
                                <!-- Hidden Form Fields 
                                <input type="text" name="deviceRoomNumber" [ngModel]="uniqueDeviceInfo.deviceRoomNumber" value="{{uniqueDeviceInfo.deviceRoomNumber }}" hidden /> 
                                -->

                                <!--
                                <div style="padding: 20px 0px;">
                                Logged In Admin ID: 26
                                </div>
                                
                                <div fxFlex>
                                    <mat-form-field class="input-full-width">
                                        <input matInput placeholder="Admin Room ID" 
                                                [value]="uniqueDeviceInfo.deviceRoomNumber"
                                                readonly="true" />
                                    </mat-form-field>      
                                </div>
                                -->
                        

                                <!-- <div fxFlex>
                                    <mat-form-field class="input-full-width">
                                        <input matInput placeholder="Unique Device Name" 
                                            #deviceName 
                                            name="deviceName" 
                                            [(ngModel)]="connectionInfo.deviceName"
                                            required />
                                    </mat-form-field>
                                </div> -->


                                <div fxFlex>
                                    <mat-form-field class="input-full-width">
                                        <mat-label>Device Court Number</mat-label>
                                        <mat-select 
                                            #deviceCourtNumber
                                            name="deviceCourtNumber" 
                                            [(ngModel)]="connectionInfo.deviceCourtNumber"
                                            required>
                                            <mat-option value="-1">Select Court Number</mat-option>
                                            <mat-option *ngFor="let court of courtNumbers" [value]="court">
                                            {{ court }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>  
                                </div>
                            

                                <!-- 
                                <mat-form-field class="input-full-width">
                                    <input matInput placeholder="Room Numbe Display Name" 
                                            #deviceRoomDisplayName 
                                            name="deviceRoomDisplayName" 
                                            [(ngModel)]="connectionInfo.deviceRoomDisplayName"
                                            required />
                                </mat-form-field>    
                        

                                <mat-form-field class="input-full-width">
                                    <input matInput placeholder="Device Court Number" 
                                            #deviceCourtNumber 
                                            name="deviceCourtNumber" 
                                            [(ngModel)]="connectionInfo.deviceCourtNumber"
                                            required />
                                </mat-form-field>      
                                            -->              

                        
                                <!--
                                <app-progress-bar *ngIf="showSpinner" style="margin-top: 15px;"></app-progress-bar>
                                -->

                                <!-- 
                                <div fxFlex>
                                    <button mat-raised-button type="button" (click)="checkDeviceSetup($event)" style="width: 100%">Check If Device is Setup</button>
                                </div>

                                <div fxFlex>
                                    <button mat-raised-button color="accent" type="submit" [disabled]="!deviceSetupForm.valid" style="width: 100%">Save Device Info</button>  
                                </div>
                                -->

                                <!-- Connection / Disconnect Buttons-->
                                <div fxFlex>
                                    <button mat-raised-button type="button" class="red-button" (click)="connectToServer(deviceSetupForm)" 
                                        [disabled]="socketInfo.readyState == 1" style="width: 100%">
                                        Connect Device to Server
                                    </button>
                                </div>                              

                                <div fxFlex>
                                    <button mat-raised-button type="button" class="red-button" (click)="disconnectFromServer()"
                                    [disabled]="socketInfo.readyState != 1" style="width: 100%">
                                        Disconnect From Server
                                    </button>
                                </div> 

                                <!-- 
                                <div fxFlex>
                                    <button mat-raised-button type="button" (click)="resetDeviceDetails()"
                                        style="width: 100%; background-color: #FFEB3B;">
                                        Reset Device Details
                                    </button>
                                </div>  
                                -->                              

                                <div fxFlex>
                                    <button mat-raised-button type="button" (click)="toggleDebug()"
                                    [disabled]="!socketInfo.connected" style="width: 100%">
                                        Toggle Debug
                                    </button>
                                </div> 

                                <div fxFlex>
                                    <button mat-raised-button type="button" (click)="removeAdminDeviceInfo()"
                                        style="width: 100%; background-color: #ffce00;">
                                        Remove Device Details
                                    </button>
                                </div>                                  

                                <div fxFlex>
                                    <button mat-raised-button type="button" style="width: 100%" (click)="getLatestMatchInfo()">Get Latest Match Info</button>
                                </div> 
                                
                                

                            </div>        
                                            
                        </mat-card>
                    </form>
                </div>


                <!-- Show Debug -->
                <div fxFlex *ngIf="showDebug">
                    <mat-card>
                        <div>

                            <div>
                                {{ deviceSetupForm.value | json }}
                            </div>
                            <!--
                            <br/>        
                            <div>
                                {{ uniqueDeviceInfo | json }}
                            </div>
                                -->
                            <br/>
                            <div>
                                <pre>
                                    Socket Status: {{ socketConnectedStatus | json }}
                                </pre>
                            </div> 
                        </div>
                    </mat-card>
                </div>



            </div>

        </div>

    </div>    

</div>

